import { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Textarea } from '../../components/ui/textarea';
import { Input } from '../../components/ui/input';
import { Copy, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';

const loremWords = [
  'lorem', 'ipsum', 'dolor', 'sit', 'amet', 'consectetur', 'adipiscing', 'elit',
  'sed', 'do', 'eiusmod', 'tempor', 'incididunt', 'ut', 'labore', 'et', 'dolore',
  'magna', 'aliqua', 'enim', 'ad', 'minim', 'veniam', 'quis', 'nostrud',
  'exercitation', 'ullamco', 'laboris', 'nisi', 'aliquip', 'ex', 'ea', 'commodo',
  'consequat', 'duis', 'aute', 'irure', 'in', 'reprehenderit', 'voluptate',
  'velit', 'esse', 'cillum', 'fugiat', 'nulla', 'pariatur', 'excepteur', 'sint',
  'occaecat', 'cupidatat', 'non', 'proident', 'sunt', 'culpa', 'qui', 'officia',
  'deserunt', 'mollit', 'anim', 'id', 'est', 'laborum'
];

const LoremIpsumTool = () => {
  const [output, setOutput] = useState('');
  const [paragraphs, setParagraphs] = useState(3);
  const [wordsPerParagraph, setWordsPerParagraph] = useState(50);

  const generateLorem = () => {
    const result = [];
    
    for (let p = 0; p < paragraphs; p++) {
      const words = [];
      for (let w = 0; w < wordsPerParagraph; w++) {
        const word = loremWords[Math.floor(Math.random() * loremWords.length)];
        words.push(w === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word);
      }
      // Add period at the end
      const paragraph = words.join(' ') + '.';
      result.push(paragraph);
    }
    
    setOutput(result.join('\n\n'));
    toast.success('Lorem Ipsum generated!');
  };

  const copyOutput = () => {
    if (output) {
      navigator.clipboard.writeText(output);
      toast.success('Copied!');
    }
  };

  return (
    <div className="space-y-4" data-testid="lorem-ipsum-tool">
      <div className="flex justify-between items-center">
        <h3 className="font-semibold">Lorem Ipsum Generator</h3>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="text-sm text-muted-foreground mb-1 block">Paragraphs</label>
          <Input
            type="number"
            min={1}
            max={20}
            value={paragraphs}
            onChange={(e) => setParagraphs(Math.min(20, Math.max(1, parseInt(e.target.value) || 1)))}
            className="bg-background/50"
          />
        </div>
        <div>
          <label className="text-sm text-muted-foreground mb-1 block">Words per paragraph</label>
          <Input
            type="number"
            min={10}
            max={200}
            value={wordsPerParagraph}
            onChange={(e) => setWordsPerParagraph(Math.min(200, Math.max(10, parseInt(e.target.value) || 50)))}
            className="bg-background/50"
          />
        </div>
      </div>

      <Button onClick={generateLorem} className="w-full" data-testid="generate-btn">
        <RefreshCw className="w-4 h-4 mr-2" />
        Generate Lorem Ipsum
      </Button>

      {output && (
        <div className="space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground">Generated Text</span>
            <Button variant="ghost" size="sm" onClick={copyOutput}>
              <Copy className="w-4 h-4 mr-1" /> Copy
            </Button>
          </div>
          <Textarea
            value={output}
            readOnly
            className="min-h-[200px] bg-background/50"
            data-testid="output"
          />
        </div>
      )}
    </div>
  );
};

export default LoremIpsumTool;
